import type {
  HostingServerView,
  HostingControlPanelKind,
  HostingControlPanelDeclaration,
} from '@tosho/contracts';
import plesk from '../assets/servers/plesk-logo.png?no-inline';
import debian from '../assets/servers/debian-logo.jpg?no-inline';
import ubuntu from '../assets/servers/ubuntu-logo.jpg?no-inline';
import linux from '../assets/servers/linux-logo.png?no-inline';
import fedora from '../assets/servers/fedora-logo.webp?no-inline';
import windows from '../assets/servers/windows-server-logo.webp?no-inline';
import webmin from '../assets/servers/webmin-logo.jpg?no-inline';
import virtualmin from '../assets/servers/virtualmin-logo.png?no-inline';
import ispconfig from '../assets/servers/ispconfig-logo.png?no-inline';
import directadmin from '../assets/servers/directadmin-logo.webp?no-inline';
import cpanel from '../assets/servers/cpanel-whm-logo.png?no-inline';
import coolify from '../assets/servers/coolify-logo.png?no-inline';
import cockpit from '../assets/servers/cockpit-logo.png?no-inline';

export const HOSTING_SYSTEMS: Readonly<
  Record<
    Exclude<HostingServerView['operatingSystem'], null>,
    { name: string; logo: string; kind: string }
  >
> = {
  UBUNTU: { name: 'Ubuntu', logo: ubuntu, kind: 'ubuntu' },
  DEBIAN: { name: 'Debian', logo: debian, kind: 'debian' },
  LINUX: { name: 'Linux (distribution non précisée)', logo: linux, kind: 'linux' },
  FEDORA: { name: 'Fedora', logo: fedora, kind: 'fedora' },
  WINDOWS_SERVER: { name: 'Windows Server', logo: windows, kind: 'windows-server' },
};
export const HOSTING_PANELS: Readonly<
  Record<HostingControlPanelKind, { name: string; logo: string }>
> = {
  PLESK: { name: 'Plesk', logo: plesk },
  WEBMIN: { name: 'Webmin', logo: webmin },
  VIRTUALMIN: { name: 'Virtualmin', logo: virtualmin },
  ISPCONFIG: { name: 'ISPConfig', logo: ispconfig },
  DIRECTADMIN: { name: 'DirectAdmin', logo: directadmin },
  CPANEL_WHM: { name: 'cPanel & WHM', logo: cpanel },
  COOLIFY: { name: 'Coolify', logo: coolify },
  COCKPIT: { name: 'Cockpit', logo: cockpit },
};

/** Les anciens DTO ne connaissent que le scalaire Plesk ; une nouvelle liste vide reste vide. */
export function declaredHostingPanels(
  server: Pick<HostingServerView, 'pleskDeclared' | 'controlPanels'>,
): readonly HostingControlPanelDeclaration[] {
  return server.controlPanels ?? [{ kind: 'PLESK', present: server.pleskDeclared }];
}
